import React, { useState, useEffect } from "react";
import UserReportGeneralInfo from "../GeneralInfo";
import CardContainer from "../../../../components/Common/CardContainer";
import ButtonInput from "../../../../components/Common/ButtonInput";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";
import * as GlobalSubmitUIDelay from "../../../../constants/AppBehaviour/globalSubmitUIDelay";
import UserDetails from "../../Users/Details";
import { API, graphqlOperation } from "aws-amplify";
import { toast } from "react-toastify";
import PagePreLoad from "../../../../components/Common/PagePreLoad";
import { getReport } from "../../../../graphql/queries";
import { updateReport } from "../../../../graphql/mutations";
import { Form, Alert } from "react-bootstrap";

const UserReportDetails = (props) => {
  const [reportUserId, setreportUserId] = useState(null);
  const [userReportData, setUserReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
  const [generalError, setGeneralError] = useState("");

  useEffect(() => {
    getUserReportData();
  }, []);

  const getUserReportData = async () => {
    try {
      const result = await API.graphql(
        graphqlOperation(getReport, { id: props.match.params.userReportId })
      );

      const { reportUserId } = result.data.getReport;

      // keep state
      setUserReportData(result);
      setreportUserId(reportUserId);
    } catch (error) {
      toast.error(
        `Error while fetching user report data ${JSON.stringify(error)}`
      );
    }
  };

  // make sure we load the page after the state for counts are updated
  useEffect(() => {
    if (reportUserId) setIsLoading(false);
  }, [reportUserId]);

  const handleReturn = () => {
    props.history.push(`/userReports`);
  };

  const handleProfaneRedirect = () => {
    props.history.push(
      `/userReports/${props.match.params.userReportId}/users/profane/${reportUserId}`
    );
  };

  const handleBlockRedirect = () => {
    props.history.push(
      `/userReports/${props.match.params.userReportId}/users/block/${reportUserId}`
    );
  };

  const handleDeleteRedirect = () => {
    props.history.push(
      `/userReports/${props.match.params.userReportId}/users/delete/${reportUserId}`
    );
  };

  const markAsAcknowledged = async (event) => {
    event.preventDefault();
    setFormSubmitInProgress(true);
    try {
      let input = {
        id: props.match.params.userReportId,
        isAcknowledged: true,
      };
      let marAsAcknowledgedResult = await API.graphql(
        graphqlOperation(updateReport, { input })
      );

      setTimeout(function () {
        toast.success(`User Report marked as Acknowledged`);
        handleReturn();
      }, GlobalSubmitUIDelay.DefaultDelay);
    } catch (error) {
      let errorMessage = `Error while updateing user report, ${JSON.stringify(
        error,
        null,
        2
      )}`;
      toast.error(errorMessage);
      setGeneralError(errorMessage);
      setFormSubmitInProgress(false);
    }
  };

  return (
    <PagePreLoad isLoading={isLoading}>
      <Form onSubmit={markAsAcknowledged} noValidate>
        <CardContainer
          header={"User Report Details"}
          backButton={
            <ButtonInput
              label="Back to List"
              type="button"
              variant={BootstrapVariants.OutlineSecondary}
              onClick={() => handleReturn()}
            />
          }
          submitButton={
            <ButtonInput
              label="Mark as Acknowledge"
              variant={BootstrapVariants.Success}
              formSubmitInProgress={formSubmitInProgress}
              formSubmittingText={"In Progress..."}
            />
          }
        >
          {generalError && (
            <Alert variant={BootstrapVariants.Danger}>{generalError}</Alert>
          )}
          <UserReportGeneralInfo
            providedModelData={userReportData}
            userReportId={props.match.params.userReportId}
          />
        </CardContainer>
      </Form>
      <CardContainer
        header={"Reported User"}
        backButton={
          <ButtonInput
            label="Back to List"
            type="button"
            variant={BootstrapVariants.OutlineSecondary}
            onClick={() => handleReturn()}
          />
        }
        extraButtons={
          <>
            <ButtonInput
              label="Mark As Profane"
              variant={BootstrapVariants.Dark}
              onClick={() => handleProfaneRedirect()}
            />
            <ButtonInput
              label="Block User"
              style={{ marginLeft: "5px" }}
              variant={BootstrapVariants.Warning}
              onClick={() => handleBlockRedirect()}
            />
            <ButtonInput
              label="Delete User"
              style={{ marginLeft: "5px" }}
              variant={BootstrapVariants.Danger}
              onClick={() => handleDeleteRedirect()}
            />
          </>
        }
      >
        <UserDetails {...props} userId={reportUserId} />
      </CardContainer>
    </PagePreLoad>
  );
};

export default UserReportDetails;
